import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import clsx from 'clsx';
function _ArrowLeftLight(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return _jsx("span", { className: classes, ref: ref, ...rest, children: _jsx("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", children: _jsx("path", { fill: "currentColor", d: "m4 12-.354-.354-.353.354.353.354zm15 .5a.5.5 0 0 0 0-1zM9.646 5.646l-6 6 .708.708 6-6zm-6 6.708 6 6 .708-.708-6-6zM4 12.5h15v-1H4z" }) }) });
}
const ArrowLeftLight = forwardRef(_ArrowLeftLight);
export { ArrowLeftLight };
